import { Typography } from "@mui/material";
import { DateTime } from "luxon";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { CalendarPager } from "../../../components/CustomCalendar/calendarPager";
import SystemButton from "../../../components/UIToolkit/SystemButton/SystemButton";
import { INK } from "../../../theme/tokens";

type ScheduleListFooterProps = {
	pager: CalendarPager;
	/** The last day of the schedule staff can see. Undefined while the schedule loads. */
	lastDay: DateTime | undefined;
};

/** Closes the schedule list: a way on to the next page, or, on the last page, how far the schedule is published. */
export const ScheduleListFooter: FC<ScheduleListFooterProps> = ({ pager, lastDay }) => {
	const { t } = useTranslation();

	if (pager.canGoNext) {
		return (
			<SystemButton buttonVariant="hairline" touchTarget onClick={pager.goNext} sx={{ width: "100%", mb: 2 }} data-testid="my-schedule-list-next">
				{t("staff.schedule.next.weeks", { weeks: pager.weekCount })}
			</SystemButton>
		);
	}
	if (!lastDay) return null;
	return (
		<Typography variant="body2" sx={{ textAlign: "center", color: INK.MUTED, py: 2, mb: 2 }} data-testid="my-schedule-published-through">
			{t("staff.schedule.published.through", { date: lastDay.toLocaleString(DateTime.DATE_MED) })}
		</Typography>
	);
};
